<script>

    import {onMount} from "svelte";
    import {GET, POST} from "../../components/communication.js";
    import {
        authToken,
        userFeatures,
        userData,
        flashSuccessMessage,
        sessionStorageRemove
    } from "../../components/stores.js";
    import {
        parseTimestampStr,
    } from "../../components/utils.js"

    let customerData = null;
    let has10xCard = false;
    let currentCardType = "Ei tiedossa"
    let loadingData = false;

    // Alustetaan vähä dataa
    onMount(async function () {
        // Haetaan käyttäjän tiedot
        getData();
    });

    async function getData() {
        loadingData = true;
        const response = GET("/c/customerData");
        const data = await response;
        if (data) {
            customerData = data;

            // Tallenna featuret localStorageen, jotta headeri voidaan päivittää.
            userFeatures.set(customerData.features);
            userData.set(customerData);

            // Käydään käyttäjän tuotteet läpi ja etsitään ennalta tiedettyjä tuotteita,
            // tämä on ihan huuhaakoodia, mutta voidaan 99% tilanteissa näyttää helpolla, että mikä tuote asiakkalla on
            // Tämä päättely pitäisi siirtää bäkkäriin
            if (customerData.customerProducts != null) {
                customerData.customerProducts.forEach(
                    function (currentValue, index, arr) {
                        // Tarkistetaan, onko 10x kortti
                        if (currentValue.name == "10x") {
                            has10xCard = true;
                        }
                        switch (currentValue.name) {
                            case "Kesäpassi 2024":
                                currentCardType = "Kesäpassi 2024"
                                break;
                            case "Kesäpassi 2023":
                                currentCardType = "Kesäpassi 2023"
                                break;
                            case "Kesäpassi 2022":
                                currentCardType = "Kesäpassi 2022"
                                break;
                            case "Kesäpassi 2021":
                                currentCardType = "Kesäpassi 2021"
                                break;
                            case "Päiväkortti":
                                currentCardType = "Päiväjäsenyys"
                                break;
                            case "Omatoimijäsen":
                                currentCardType = "Omatoimijäsenyys"
                                break;
                            case "1kk toistaiseksi voimassaoleva":
                                currentCardType = "Täysjäsenyys"
                                break;
                            case "10x":
                                currentCardType = "10x"
                                break;
                            case "1kk jäsen":
                                currentCardType = "1kk jäsen"
                                break;
                            case "6kk jäsen":
                                currentCardType = "6kk jäsen"
                                break;
                            case "12kk jäsen":
                                currentCardType = "12kk jäsen"
                                break;
                            default:
                            // Ei tehdä mitään
                        }
                    }
                )
            }
            loadingData = false;
        }
    }

    async function logoutUser() {
        sessionStorageRemove("authToken");
        authToken.set('');
        sessionStorage.clear();
        window.location.href = '/';
    }
</script>
<div class="page">
    <div class="container">
        {#if customerData}
            <div class="row">
                <div class="col-md-6">
                    <div class="card" style="width: 28rem;">
                        <div class="card-body">
                            <h4 class="card-title">{customerData.firstname} {customerData.lastname}</h4>

                            <label for="lastVisit">Viimeisin käynti: </label>
                            <div id="lastVisit">
                                {#if customerData.lastvisit}
                                    <b>{parseTimestampStr(customerData.lastvisit)}</b>
                                {:else}
                                    Ei tiedossa.
                                {/if}
                            </div>
                            <br/>
                            <label for="cardType">Korttityyppi: </label>
                            <div id="cardType"><b>{currentCardType}</b></div>
                            <br>
                            <label for="cardValid">Kortti on voimassa:</label>
                            <div id="cardValid"><b>
                                {#if customerData.cardExpire == null} Toistaiseksi
                                {:else} <b>{parseTimestampStr(customerData.cardExpire)}</b>{/if}
                            </b></div>

                            {#if has10xCard}
                                <label for="10xCardLeft">10x kortista jäljellä:</label>
                                <div id="10xCardLeft"><b>{10 - customerData.serialCardVisitCount}</b></div>
                            {/if}
                            <br/><br/>
                            <button on:click|preventDefault={logoutUser} class="btn btn-secondary">Kirjaudu ulos
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
        {#if loadingData}
            Haetaan tietoja ...
        {/if}
    </div>
</div>
